<div class="pre-checkin-container">
  <div *ngIf="isLoading" class="loading-container">
    <div class="spinner"></div>
    <p>Loading your reservation...</p>
  </div>

  <div *ngIf="!isLoading && errorMessage" class="error-container">
    <div class="error-icon">⚠️</div>
    <h2>Oops!</h2>
    <p>{{ errorMessage }}</p>
    <p class="error-hint">Please contact the hotel reception for assistance.</p>
  </div>

  <div *ngIf="!isLoading && !errorMessage && resa" class="content-container">

    <section class="welcome-section">
      <div class="hotel-branding" *ngIf="hotelLogo">
        <img [src]="hotelLogo" [alt]="hotelName + ' Logo'" class="hotel-logo-img">
      </div>
      <div class="welcome-text">
        <h2>Welcome, {{ mainGuest?.name || (mainGuest?.firstName + ' ' + mainGuest?.lastName) }}</h2>
        <p class="instruction-text">
          Please to make the your check-in process faster, please provide the necessary information for all guests in your reservation.
        </p>
      </div>
    </section>

    <section class="info-card">
      <h3>Reservation Details</h3>
      <div class="info-grid">
        <div class='info-item' *ngIf="hotelName">
          <label>Hotel</label>
          <span>{{ hotelName }}</span>
        </div>
        <div class="info-item">
          <label>Check-in Date</label>
          <span>{{ formattedDatearrived }}</span>
        </div>
        <div class="info-item">
          <label>Check-out Date</label>
          <span>{{ formattedDatedepart }}</span>
        </div>
        <div class="info-item">
          <label>Number of Nights</label>
          <span>{{ Numberofneight }}</span>
        </div>
        <div class="info-item">
          <label>Room Type</label>
          <span>{{ roomTypeinvoiced }}</span>
        </div>
        <div class="info-item" *ngIf="resa?.roomName">
          <label>Room Number</label>
          <span>{{ resa.roomName }}</span>
        </div>
        <div class="info-item">
          <label>Meal Plan</label>
          <span>{{ Item?.tags?.split(";")[2] || 'All Inclusive' }}</span>
        </div>
      </div>
    </section>

    <section class="info-card guests-section">
      <h3>Guests Information</h3>
      <div class="guests-summary">
        <span class="guest-count">{{ NumberAdults }} Adult(s)</span>
        <span class="guest-count" *ngIf="NumberKids > 0">{{ NumberKids }} Child(ren)</span>
        <span class="guest-count" *ngIf="NumberBbKids > 0">{{ NumberBbKids }} Infant(s)</span>
      </div>
      
      <!-- <p class="section-instruction">Please complete the information for all guests below.</p> -->

      <div class="all-guests-container">
        <ng-container *ngFor="let guest of beneficiaries; let i = index">
          <div class="guest-form-card" *ngIf="getGuestFormData(i) as formData">
            
            <div class="guest-form-header">
              <div class="guest-number">
                <span class="number-badge">{{ i + 1 }}</span>
                <span class="guest-label">
                  {{ formData.client?.firstName ? formData.client.firstName + ' ' + formData.client.lastName : 'Guest ' + (i + 1) }}
                </span>
              </div>
              <div class="guest-status">
                <span class="status-complete" *ngIf="completedGuests.has(i)"> </span>
                <span class="status-incomplete" *ngIf="!completedGuests.has(i)">⚠ Incomplete</span>
              </div>
            </div>

            <!-- Guest Edit Form - ALWAYS VISIBLE -->
            <div class="guest-form-body">
              
              <!-- Row 1: Title, First Name, Last Name -->
              <div class="form-row">
                <div class="form-group small">
                  <label>Title</label>
                  <select [(ngModel)]="formData.client.title.name">
                    <option value="No Title">No Title</option>
                    <option value="Mr">Mr.</option>
                    <option value="Mme">Mme.</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>First Name <span class="required">*</span></label>
                  <input type="text" [(ngModel)]="formData.client.firstName" placeholder="First name">
                </div>
                <div class="form-group">
                  <label>Last Name <span class="required">*</span></label>
                  <input type="text" [(ngModel)]="formData.client.lastName" placeholder="Last name">
                </div>
              </div>

              <!-- Row 2: Email, Phone -->
              <div class="form-row">
                <div class="form-group">
                  <label>Email</label>
                  <input type="email" [(ngModel)]="formData.client.mainEmail.address" placeholder="Email address">
                </div>
                <div class="form-group">
                  <label>Phone</label>
                  <input type="tel" [(ngModel)]="formData.client.mainPhone.number" placeholder="Phone number">
                </div>
              </div>

              <!-- Row 3: Country -->
              <div class="form-row single">
                <div class="form-group full-width">
                  <label>Country <span class="required">*</span></label>
                  <div class="flag-selector">
                    <img src="https://flagcdn.com/w20/ma.png" alt="Morocco" (click)="selectGuestCountry(0, i)" 
                         [class.selected]="formData.client.country?.alpha2 === 'ma'">
                    <img src="https://flagcdn.com/w20/fr.png" alt="France" (click)="selectGuestCountry(1, i)" 
                         [class.selected]="formData.client.country?.alpha2 === 'fr'">
                    <img src="https://flagcdn.com/w20/de.png" alt="Germany" (click)="selectGuestCountry(2, i)" 
                         [class.selected]="formData.client.country?.alpha2 === 'de'">
                    <img src="https://flagcdn.com/w20/gb.png" alt="UK" (click)="selectGuestCountry(3, i)" 
                         [class.selected]="formData.client.country?.alpha2 === 'gb'">
                    <img src="https://flagcdn.com/w20/us.png" alt="USA" (click)="selectGuestCountry(4, i)" 
                         [class.selected]="formData.client.country?.alpha2 === 'us'">
                    <img src="https://flagcdn.com/w20/be.png" alt="Belgium" (click)="selectGuestCountry(5, i)" 
                         [class.selected]="formData.client.country?.alpha2 === 'be'">
                    <img src="https://flagcdn.com/w20/ae.png" alt="UAE" (click)="selectGuestCountry(6, i)" 
                         [class.selected]="formData.client.country?.alpha2 === 'ae'">
                  </div>
                  <div class="search-input-container">
                    <input type="text" 
                           [value]="formData.client.country?.name || ''"
                           (input)="onGuestCountryInput($event, i)"
                           placeholder="Type country name...">
                    <div class="search-results" *ngIf="formData.countrySearchResults && formData.countrySearchResults.length > 0">
                      <div class="search-result-item" 
                           *ngFor="let country of formData.countrySearchResults" 
                           (click)="selectGuestCountryFromSearch(country, i)">
                        {{ country.name }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Row 4: Nationality -->
              <div class="form-row single">
                <div class="form-group full-width">
                  <label>Nationality <span class="required">*</span></label>
                  <div class="flag-selector">
                    <img src="https://flagcdn.com/w20/ma.png" alt="Morocco" (click)="selectGuestNationality(0, i)" 
                         [class.selected]="formData.client.nationality?.name === 'Maroc' || formData.client.nationality?.alpha2 === 'ma'">
                    <img src="https://flagcdn.com/w20/fr.png" alt="France" (click)="selectGuestNationality(1, i)" 
                         [class.selected]="formData.client.nationality?.name === 'France' || formData.client.nationality?.alpha2 === 'fr'">
                    <img src="https://flagcdn.com/w20/de.png" alt="Germany" (click)="selectGuestNationality(2, i)" 
                         [class.selected]="formData.client.nationality?.name === 'Allemagne' || formData.client.nationality?.alpha2 === 'de'">
                    <img src="https://flagcdn.com/w20/gb.png" alt="UK" (click)="selectGuestNationality(3, i)" 
                         [class.selected]="formData.client.nationality?.name === 'Royaume-Uni' || formData.client.nationality?.alpha2 === 'gb'">
                    <img src="https://flagcdn.com/w20/us.png" alt="USA" (click)="selectGuestNationality(4, i)" 
                         [class.selected]="formData.client.nationality?.name === 'États-Unis' || formData.client.nationality?.alpha2 === 'us'">
                    <img src="https://flagcdn.com/w20/be.png" alt="Belgium" (click)="selectGuestNationality(5, i)" 
                         [class.selected]="formData.client.nationality?.name === 'Belgique' || formData.client.nationality?.alpha2 === 'be'">
                    <img src="https://flagcdn.com/w20/ae.png" alt="UAE" (click)="selectGuestNationality(6, i)" 
                         [class.selected]="formData.client.nationality?.name === 'Émirats arabes unis' || formData.client.nationality?.alpha2 === 'ae'">
                  </div>
                  <div class="search-input-container">
                    <input type="text" 
                           [value]="formData.client.nationality?.name || ''"
                           (input)="onGuestNationalityInput($event, i)"
                           placeholder="Type nationality...">
                    <div class="search-results" *ngIf="formData.nationalitySearchResults && formData.nationalitySearchResults.length > 0">
                      <div class="search-result-item" 
                           *ngFor="let nat of formData.nationalitySearchResults" 
                           (click)="selectGuestNationalityFromSearch(nat, i)">
                        {{ nat.name }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Row 5: Date of Birth -->
               <div class="date-birth-section">
                  <label class="block" style="display:block; margin-bottom: 5px; margin-left: -5px;"> 
                    Date of Birth <span class="required">*</span>
                  </label>

                  <div class="form-row">
                    
                    <div class="form-group">
                      <label>Day</label>
                      <select [(ngModel)]="formData.dayBirth">
                        <option [ngValue]="null">Day</option>
                        <option *ngFor="let day of days" [ngValue]="day">{{ day }}</option>
                      </select>
                    </div>

                    <div class="form-group">
                      <label>Month</label>
                      <select [(ngModel)]="formData.monthBirth" [compareWith]="comparMounthFn">
                        <option [ngValue]="null">Month</option>
                        <option *ngFor="let month of months" [ngValue]="month.value">{{ month.name }}</option>
                      </select>
                    </div>

                    <div class="form-group">
                      <label>Year</label>
                      <select [(ngModel)]="formData.yearBirth">
                        <option [ngValue]="null">Year</option>
                        <option *ngFor="let year of years" [ngValue]="year">{{ year }}</option>
                      </select>
                    </div>

                  </div>
                </div>

              <!-- Row 6: Document Type & ID -->
              <div class="form-row" *ngIf="ListTypedocument.length > 0">
                <div class="form-group">
                  <label>ID Type</label>
                  <select [(ngModel)]="formData.docType" [compareWith]="comparDocTypeFn"
                          (ngModelChange)="onGuestDocTypeChange(i)">
                    <option [ngValue]="null">Select ID Type</option>
                    <option *ngFor="let doctype of ListTypedocument" [ngValue]="doctype">
                      {{ doctype.name }}
                    </option>
                  </select>
                </div>
                <div class="form-group" *ngIf="formData.filteredSubDocTypes.length > 0">
                  <label>Document Sub-Type</label>
                  <select [(ngModel)]="formData.subDocType" [compareWith]="comparSubDocTypeFn">
                    <option [ngValue]="null">Select Sub-Type</option>
                    <option *ngFor="let subDocType of formData.filteredSubDocTypes" [ngValue]="subDocType">
                      {{ subDocType.name }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label>ID Number</label>
                  <input type="text" [(ngModel)]="formData.document.code" placeholder="Document number">
                </div>
              </div>

              <!-- Validation Error -->
              <div class="error-message" *ngIf="formData.showError">
                Please complete the required fields: First Name, Last Name, Country, and Nationality are mandatory.
              </div>

              <!-- Save Button for this guest -->
              <div class="guest-save-actions">
                <button class="btn-save-guest" (click)="saveGuest(i)">
                  Save Guest {{ i + 1 }}
                </button>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <!-- Error Summary -->
      <div class="error-summary" *ngIf="!areAllGuestsComplete() && beneficiaries.length > 0">
        <span class="error-icon">⚠️</span>
        <span class="error-text">Some guests have incomplete information. Please complete all required fields before submitting.</span>
      </div>

      <!-- Submit Section -->
      <div class="submit-section">
        <button class="btn-submit-all" 
                (click)="submitAndDownloadFiche()"
                [disabled]="isSubmitting || resa.reservationStatus === 'CANCELLED' || resa.reservationStatus === 'NOSHOW' || resa.reservationStatus === 'CHECKEDOUT'">
          <span *ngIf="!isSubmitting">
            <!-- <span class="btn-icon">📄</span> -->
            Submit All & Download Form
          </span>
          <span *ngIf="isSubmitting" class="loading-text">
            <span class="btn-spinner"></span>
            Processing...
          </span>
        </button>
      </div>
    </section>

    <!-- Status Messages -->
    <section class="status-section" *ngIf="resa.reservationStatus === 'CHECKEDOUT' || resa.reservationStatus === 'CANCELLED' || resa.reservationStatus === 'NOSHOW'">
      <p class="action-note" *ngIf="resa.reservationStatus === 'CHECKEDOUT'">
        This reservation has already been checked out.
      </p>
      <p class="action-note" *ngIf="resa.reservationStatus === 'CANCELLED' || resa.reservationStatus === 'NOSHOW'">
        This reservation is no longer active.
      </p>
    </section>

  </div>

  <footer class="pre-checkin-footer">
    <p>&copy; {{ currentYear }} - All rights reserved</p>
  </footer>
</div>